// extracted by mini-css-extract-plugin
export var activeFilterButton = "_sf-c";
export var backButton = "_sf-4";
export var backIcon = "_sf-5";
export var chevronShortcut = "_sf-6";
export var container = "_sf-1";
export var editor = "_sf-8";
export var editorWrapper = "_sf-7";
export var prefix = "_sf-2";
export var searchIcon = "_sf-3";
export var suffix = "_sf-9";
export var suffixContent = "_sf-a";
export var suffixText = "_sf-b";
export var wrapper = "_sf-0";